



































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import DateTimePicker from '@c/controls/DateTimePicker.vue';
import {dateTimeIntervals, dateTimeIntervalHandle, DatesIntervals} from '@u/dateTimeItervalUtils';
import {DateTimeInterval} from '@u/dateTimeItervalUtils';

@Component({components: {DateTimePicker}})
export default class IntervalDateTimeSelect extends Vue {
  private selectValue: DatesIntervals = 'today';
  private startDate = dateTimeIntervalHandle(this.selectValue).startDateTime;
  private endDate = dateTimeIntervalHandle(this.selectValue).endDateTime;
  private items = dateTimeIntervals;

  @Prop({type: Boolean, default: true}) isShowSelectIntervals!: boolean;

  @Prop() initValue!: DateTimeInterval;

  // аргумент - значение value из items
  private onChange() {
    const {startDateTime, endDateTime} = dateTimeIntervalHandle(this.selectValue);
    this.startDate = startDateTime;
    this.endDate = endDateTime;
  }

  private onClickDate() {
    this.selectValue = '';
  }

  @Watch('startDate', {immediate: true})
  onStartDateChanged() {
    this.$emit('setDateTimeInterval', {startDateTime: this.startDate, endDateTime: this.endDate});
  }

  @Watch('endDate', {immediate: true})
  onEndDateChanged() {
    this.$emit('setDateTimeInterval', {startDateTime: this.startDate, endDateTime: this.endDate});
  }

  changeStartDate(value: number) {
    this.startDate = value;
  }

  changeEndDate(value: number) {
    this.endDate = value;
  }

  @Watch('initValue', {immediate: true})
  onSetInitValue(newVal: DateTimeInterval) {
    if (!newVal || !newVal.startDateTime || !newVal.endDateTime) return;
    this.startDate = newVal.startDateTime;
    this.endDate = newVal.endDateTime;
  }
}
